/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ExploreSection from '../../../components/Groups/ExploreSection/ExploreSection';
import LanderChoice from '../../../components/Groups/LanderChoice/LanderChoice';
import LanderHeader from '../../../components/Groups/LanderHeader/LanderHeader';
import MarketingSection from '../../../components/Groups/MarketingSection/MarketingSection';
import SearchPageSection from '../../../components/Groups/Search/SearchPageSection/SearchPageSection';
import { GroupCondensedPropShape } from '../../../components/Includes/GroupPropsShape';
import { buildImagePath } from '../../../components/JobComponents/Company/Image/logo';
import Layout from '../../../components/Layout/Layout';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

import './Lander.scss';

export class Lander extends React.PureComponent {
    constructor(props) {
        super();

        this.createImgSrc = buildImagePath(
            '/v1569951461/add-icon_ow46b9.svg',
            'default',
            { default: '' }
        );
        this.discoverImgSrc = buildImagePath(
            '/v1569951461/search-icon_gsistl.svg',
            'default',
            { default: '' }
        );
        this.transitionDuration = 750;
        this.marketingRef = React.createRef();
        this.marketingExtraRef = React.createRef();
        this.discoverRef = React.createRef();
        this.discoverExtraRef = React.createRef();

        this.state = {
            containerStyle: {},
            initialLoad:
                [
                    '/groups/create',
                    '/groups/create/',
                    '/groups/search',
                    '/groups/search/',
                ].indexOf(props.location.pathname) !== -1, // should only be set true when loading an open card page
            transitionsEnabled: true,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scroll({ top: 0, behavior: 'smooth' });
        }
    }

    resizeContainer = async (newHeight = null) => {
        if (newHeight !== null) {
            if (this.state.initialLoad) {
                await this.setState({ transitionsEnabled: false });
                await this.setState({
                    containerStyle: { height: `${newHeight}px` },
                    initialLoad: false,
                });
                setTimeout(
                    () => this.setState({ transitionsEnabled: true }),
                    0
                );
                return;
            }

            this.setState({ containerStyle: { height: `${newHeight}px` } });
            return;
        }

        const {
            marketingRef,
            marketingExtraRef,
            discoverRef,
            discoverExtraRef,
            props: {
                location: { pathname },
            },
        } = this;

        let childRef = null;
        let extraRef = null;

        switch (pathname) {
            case '/groups/create/':
            case '/groups/create':
                childRef = marketingRef;
                extraRef = marketingExtraRef;
                break;
            case '/groups/search/':
            case '/groups/search':
                childRef = discoverRef;
                extraRef = discoverExtraRef;
                break;
            default:
                this.setState({ containerStyle: {} });
                return;
        }

        if (this.state.initialLoad) {
            await this.setState({ transitionsEnabled: false });
            await this.setState({
                containerStyle: {
                    height: `${
                        childRef.current.clientHeight +
                        ((extraRef &&
                            extraRef.current &&
                            extraRef.current.clientHeight) ||
                            0) +
                        40
                    }px`,
                },
                initialLoad: false,
            });
            setTimeout(() => this.setState({ transitionsEnabled: true }), 0);
            return;
        }

        this.setState({
            containerStyle: {
                height: `${
                    childRef.current.clientHeight +
                    ((extraRef &&
                        extraRef.current &&
                        extraRef.current.clientHeight) ||
                        0) +
                    40
                }px`,
            },
        });
    };

    renderMarketingSectionWithCta = () => {
        const { marketingRef } = this;
        return (
            <div
                className="page-Groups-Lander__choice-child"
                ref={marketingRef}
            >
                <MarketingSection />
            </div>
        );
    };

    renderSearchWithCta = () => {
        const {
            discoverRef,
            props: { searchProps },
        } = this;
        const { queries, groupsMatches } = searchProps || {};

        return (
            <div className="page-Groups-Lander__choice-child" ref={discoverRef}>
                <SearchPageSection {...queries} searchMatches={groupsMatches} />
            </div>
        );
    };

    render() {
        const {
            props: {
                numberOfUsers,
                location,
                match,
                history,
                popularGroups,
                newGroups,
            },
            createImgSrc,
            discoverImgSrc,
            transitionDuration,
            marketingRef,
            marketingExtraRef,
            discoverRef,
            discoverExtraRef,
            resizeContainer,
        } = this;

        const routeData = { match, location, history };
        const cardShellCls = 'page-Groups-Lander__card-wrapper';
        const cardShellTransitionProps = {
            classNames: {
                appear: `${cardShellCls}--appear`,
                appearActive: `${cardShellCls}--appear-active`,
                appearDone: `${cardShellCls}--appear-done`,
                enter: `${cardShellCls}--enter`,
                enterActive: `${cardShellCls}--enter-active`,
                enterDone: `${cardShellCls}--enter-done`,
                exit: `${cardShellCls}--exit`,
                exitActive: `${cardShellCls}--exit-active`,
                exitDone: `${cardShellCls}--exit-done`,
            },
            timeout: transitionDuration,
        };

        const hasOpenCard =
            [
                '/groups/create',
                '/groups/create/',
                '/groups/search',
                '/groups/search/',
            ].indexOf(routeData.location.pathname) !== -1;

        const choicesClass = `page-Groups-Lander__choices${
            hasOpenCard ? ' page-Groups-Lander__choices--card-opened' : ''
        }${
            this.state.initialLoad && hasOpenCard
                ? ' page-Groups-Lander__choices--initial-load'
                : ''
        }${
            !this.state.transitionsEnabled
                ? ' page-Groups-Lander__choices--no-transition'
                : ''
        }`;

        const createWrapperClassName = `page-Groups-Lander__card-wrapper page-Groups-Lander__card-wrapper--create${
            routeData.location.pathname === '/groups/create'
                ? ' page-Groups-Lander__card-wrapper--is-open'
                : ''
        }`;

        const discoverWrapperClassName = `page-Groups-Lander__card-wrapper page-Groups-Lander__card-wrapper--discover${
            routeData.location.pathname === '/groups/search'
                ? ' page-Groups-Lander__card-wrapper--is-open'
                : ''
        }`;

        return (
            <div className="page-Groups-Lander">
                <SnowplowPageViewTracker
                    pageSection={PAGE_VIEW_SECTIONS.GROUPS}
                    pageType={PAGE_VIEW_TYPES.COLLECTION}
                />
                <Layout>
                    <div className="background">
                        <div className="blurred-background" />
                        <div className="gradient-to-solid-pink" />
                    </div>
                    <section className="main-content">
                        <LanderHeader numberOfUsers={numberOfUsers} />
                        <div
                            className={choicesClass}
                            style={this.state.containerStyle}
                        >
                            <TransitionGroup className="page-Groups-Lander__transitions">
                                {[
                                    '/groups',
                                    '/groups/',
                                    '/groups/create',
                                    '/groups/create/',
                                ].indexOf(routeData.location.pathname) !==
                                    -1 && (
                                    <CSSTransition
                                        key="transition-create"
                                        {...cardShellTransitionProps}
                                    >
                                        <div className={createWrapperClassName}>
                                            <LanderChoice
                                                handle="create"
                                                img={{
                                                    src: createImgSrc,
                                                }}
                                                headline="Create a new group"
                                                bodyCopy="Start a group to connect with like-minded women."
                                                cta={{
                                                    path: '/groups/create',
                                                    text: 'Learn more',
                                                }}
                                                transitionDuration={
                                                    transitionDuration
                                                }
                                                childRef={marketingRef}
                                                extraRef={marketingExtraRef}
                                                routeData={routeData}
                                                isOpen={
                                                    routeData.location
                                                        .pathname ===
                                                    '/groups/create'
                                                }
                                                resizeContainer={
                                                    resizeContainer
                                                }
                                                containerStyle={
                                                    this.state.containerStyle
                                                }
                                                metricsType="create-group"
                                            >
                                                {this.renderMarketingSectionWithCta()}
                                            </LanderChoice>
                                            <CSSTransition
                                                timeout={transitionDuration}
                                                in={
                                                    [
                                                        '/groups/create',
                                                        '/groups/create/',
                                                    ].indexOf(
                                                        routeData.location
                                                            .pathname
                                                    ) !== -1
                                                }
                                                unmountOnExit
                                            >
                                                <div
                                                    className="cta-line"
                                                    ref={marketingExtraRef}
                                                >
                                                    Get inspired.{' '}
                                                    <Link to="/groups/search">
                                                        Search all groups
                                                    </Link>{' '}
                                                    on FGB.
                                                </div>
                                            </CSSTransition>
                                        </div>
                                    </CSSTransition>
                                )}
                                {[
                                    '/groups',
                                    '/groups/',
                                    '/groups/search',
                                    '/groups/search/',
                                ].indexOf(routeData.location.pathname) !==
                                    -1 && (
                                    <CSSTransition
                                        key="transition-discover"
                                        {...cardShellTransitionProps}
                                    >
                                        <div
                                            className={discoverWrapperClassName}
                                        >
                                            <LanderChoice
                                                handle="discover"
                                                img={{
                                                    src: discoverImgSrc,
                                                }}
                                                headline="Discover groups"
                                                bodyCopy="Search by keywords, interests, and locations."
                                                cta={{
                                                    path: '/groups/search',
                                                    text: 'Search',
                                                }}
                                                transitionDuration={
                                                    transitionDuration
                                                }
                                                childRef={discoverRef}
                                                extraRef={discoverExtraRef}
                                                routeData={routeData}
                                                isOpen={
                                                    routeData.location
                                                        .pathname ===
                                                    '/groups/search'
                                                }
                                                resizeContainer={
                                                    resizeContainer
                                                }
                                                containerStyle={
                                                    this.state.containerStyle
                                                }
                                                metricsType="search-groups"
                                            >
                                                {this.renderSearchWithCta()}
                                            </LanderChoice>
                                            <CSSTransition
                                                timeout={transitionDuration}
                                                in={
                                                    [
                                                        '/groups/search',
                                                        '/groups/search/',
                                                    ].indexOf(
                                                        routeData.location
                                                            .pathname
                                                    ) !== -1
                                                }
                                                unmountOnExit
                                            >
                                                <div
                                                    className="cta-line"
                                                    ref={discoverExtraRef}
                                                >
                                                    <Link to="/groups/create">
                                                        Create a new group
                                                    </Link>{' '}
                                                    on Fairygodboss &gt;
                                                </div>
                                            </CSSTransition>
                                        </div>
                                    </CSSTransition>
                                )}
                            </TransitionGroup>
                        </div>
                        <ExploreSection
                            popularGroups={popularGroups}
                            newGroups={newGroups}
                        />
                    </section>
                </Layout>
            </div>
        );
    }
}

Lander.defaultProps = {
    newGroups: [],
    popularGroups: [],
    numberOfUsers: 0,
    searchProps: {},
};

Lander.propTypes = {
    history: PropTypes.shape().isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
    match: PropTypes.shape().isRequired,
    /**
     * array of objects of recommended new groups
     */
    newGroups: PropTypes.arrayOf(PropTypes.shape(GroupCondensedPropShape)),
    /**
     * array of objects of recommended new groups
     */
    popularGroups: PropTypes.arrayOf(PropTypes.shape(GroupCondensedPropShape)),
    /**
     * # search object including search query and results objects (if any results exists)
     */
    searchProps: PropTypes.shape({
        queries: PropTypes.shape({
            keyword: PropTypes.string,
            interests: PropTypes.arrayOf(
                PropTypes.shape({
                    /**
                     * interst name
                     */
                    name: PropTypes.string,
                    /**
                     * interest id
                     */
                    id: PropTypes.number,
                })
            ),
            locations: PropTypes.arrayOf(
                PropTypes.shape({
                    /**
                     * location name
                     */
                    name: PropTypes.string,
                    /**
                     * location latitude
                     */
                    latitude: PropTypes.string,
                    /**
                     * location longitude
                     */
                    longitude: PropTypes.string,
                })
            ),
        }),
        groupsMatches: PropTypes.shape({
            results: PropTypes.arrayOf(
                PropTypes.shape({
                    group: PropTypes.shape(GroupCondensedPropShape),
                    matches: PropTypes.shape({
                        interests: PropTypes.arrayOf(
                            PropTypes.shape({
                                /**
                                 * interst name
                                 */
                                name: PropTypes.string,
                                /**
                                 * interest id
                                 */
                                id: PropTypes.number,
                            })
                        ),
                        locations: PropTypes.arrayOf(
                            PropTypes.shape({
                                /**
                                 * location name
                                 */
                                name: PropTypes.string,
                                /**
                                 * location latitude
                                 */
                                latitude: PropTypes.number,
                                /**
                                 * location longitude
                                 */
                                longitude: PropTypes.number,
                            })
                        ),
                    }),
                })
            ),
            resultsPerPage: PropTypes.number,
            startNum: PropTypes.number,
            endNum: PropTypes.number,
            total: PropTypes.number,
        }),
    }),
    /**
     * # of active community users
     */
    numberOfUsers: PropTypes.number,
};

export default withRouter(Lander);
